import React from 'react';

import DocumentTitle from 'bz-core-controls/controls/document-title';
import Fallback from 'bz-core-controls/controls/lazy/controls/fallback';
import { DialogStoreProvider } from 'bz-stores/mobx/dialog-store';
import { observer } from 'mobx-react';
import { Redirect, Route, Switch } from 'react-router';
const JobSheetDesktop = React.lazy(() => import('../../work-sheets/job-sheets/desktop'));

export interface IParams {
  id: string;
}
export interface IProps {}

export const JobsheetPaths = {
  index: '/jobsheets',
  details: '/jobsheets/:sheetId',
  cloneRedirect: '/jobsheets/clone/:id'
};

const JobsheetsSwitch: React.FC<IProps> = observer(() => {
  return (
    <DialogStoreProvider>
      <>
        <DocumentTitle title="TM3 > Job sheets" />
        <React.Suspense fallback={<Fallback />}>
          <Switch>
            <Redirect path={JobsheetPaths.cloneRedirect} to={JobsheetPaths.details} />
            <Route
              path={[JobsheetPaths.details, JobsheetPaths.index]}
              component={JobSheetDesktop}
            />
          </Switch>
        </React.Suspense>
      </>
    </DialogStoreProvider>
  );
});

export default JobsheetsSwitch;
